import { GetLinks } from "../../../config";

export default [
  {
    key: "/business-360",
    icon: <i className="ki-outline ki-briefcase fs-1 " />,
    label: GetLinks("/business-360", "Business 360"),
  },
];
